import styled, { css } from 'styled-components'

const PRIMARY = 'primary'
const SECONDARY = 'secondary'

export const TextFieldContainer = styled.label`
  display: flex;
  flex-direction: column;
`

export const TextFieldSubContainer = styled.div`
  * {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
  }

  display: flex;
  flex: 1;

  ${props =>
    props.variant === PRIMARY &&
    css`
      background-color: var(--grey-7);
      border-top-left-radius: var(--2xs);
      border-bottom-left-radius: var(--2xs);

      border: var(--5xs) solid var(--grey-6);

      padding-left: var(--base);
      padding-top:var(--base);
      padding-bottom: var(--sm);

      ${(props.focused || props.touched) &&
        css`
          background-color: var(--white);
          border-width: var(--4xs);
          border-color: var(--blue);

          & span {
            color: var(--blue);
          }
        `}

      background-color: ${props.focused ? 'var(--white)' : 'var(--grey-7)'};

      ${props.error &&
        css`
          border-color: var(--red);
          border-width: var(--4xs);
        `}
    `}

  ${props =>
    props.variant === SECONDARY &&
    css`
      border: var(--5xs) solid var(--grey-7);
      border-bottom: var(--5xs) solid var(--clr-accent-to-text);

      ${(props.focused || props.touched) &&
        css`
          border: var(--5xs) solid var(--clr-accent-to-text)};
        `}

      ${props.error &&
        css`
          border: var(--5xs) solid var(--orange);
          border-bottom: var(--3xs) var(--orange);
        `}

      ${props.validated &&
        css`
          border: var(--5xs) solid var(--grey-7);
          border-bottom: var(--3xs) solid var(--green);
        `}
    `}

  position: relative
  transition: all 0.7s;
  overflow: hidden;

  ${props =>
    props.isSearchBox &&
    css`
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      height: var(--5xl);
      padding-top: var(--xs);
      width: 100%;
      width: var(--12xl);
      
      @media only screen and (max-width: 768px) {
        width: var(--11xl);
      }
    `}
`

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 0%;

  ${props =>
    props.variant === SECONDARY &&
    css`
      input {
        border: none;
        padding: 10px 12px 10px 12px;
        padding-top: var(--1xs);
        padding-right: var(--xs);
        padding-bottom: var(--1xs);
        padding-left: var(--xs);
        flex: 1 1 0%;
      }
    `}

  ${props =>
    props.variant === PRIMARY &&
    css`
      & > span {
        transition: all 0.5s;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
      }

      & input {
        transition: all 0.5s 0.4s;
        width: 100%;
        border: none;
        background-color: transparent;
        font-weight: 600;
      }

      & p {
        opacity: 0;
      }

      ${props.isSearchBox &&
        css`
          & > span {
            font-size: var(--sm);
          }

          & input {
            transition: all 0.5s 0.4s;
            width: 100%;
            border: none;
            background-color: transparent;
            font-size: var(--xs);
          }
        `}

      ${(props.focused || props.touched) &&
        css`
          & > span {
            color: var(--blue);
            top: -var(--xs);
            font-size: var(--xs);
          }

          & p {
            opacity: 1;
            transform: translateY(5px);
          }

          & input {
            transform: translateY(3px);
          }
        `}
    `}

  input:focus {
    outline: none;
  }
`

export const ButtonIconContainer = styled.div`
  background-color: var(--clr-accent-to-black);
  padding: var(--1xs) var(--3xs);
  background-color: ${props => props.searchButtonColor};

  ${props =>
    props.variant === PRIMARY &&
    css`
      border-top-right-radius: var(--2xs);
      border-bottom-right-radius: var(--2xs);
    `}
`

export const LabelContainer = styled.p`
  margin: 0px;
  font-size: var(--dropdown-label-size);
  padding-bottom: var(--1xs);
  font-weight: 400;
`

export const Wrapper = styled.div`
  width: var(--search-input-width);
`



// WEBPACK FOOTER //
// ./src/components/SearchField/styles.js